import * as service from './Jobdetails.services'

export default {

  data() {
    return {
      iseditable: true,
      disableForRoleOrdination: false,
      jobForm: {
        PersonnelId: '',
        HiredOn: '',
        EmployeeId: '',
        LocationId: '',
        role: '',
        isself: false,
        PositionId: '',
        ActiveStatus: '',
        CurrentSalary: '',
        CurrentPayRate: '',
        NextPayChange: '',
        TerminationDate: '',
        TerminatedBy: '',
        TerminationReason: '',
        TerminatedStatus: '',
        ChangeSalaries: [],
        username: '',
        IsActive: ''

      },
      locations: [],
      positions: [],
      users: [],
      salaries: [],
      personelId: '',
      locationNames: '',
      positionNames: '',
      salaryBack: []

    }
  },
  mounted() {

    if (this.$route.params.id) {
      this.personelId = this.$route.params.id
      this.GetMainUsers(this.$route.params.id)
    }

    this.getLocations()
    this.getPosition()

    this.role = JSON.parse(localStorage.getItem('authentication')).role
    this.isself = (this.personelId == JSON.parse(localStorage.getItem('authentication')).PersonnelId) ? true : false

  },
  props: ['data', 'editShow'],
  watch: {
    data: function () {

      this.responseModel = {
        PersonnelId: this.data.response.PersonnelId,
        HiredOn: this.data.response.HiredOn,
        EmployeeId: this.data.response.EmployeeId,
        LocationId: this.data.response.LocationId,

        PositionId: this.data.response.PositionId,
        ActiveStatus: this.data.response.ActiveStatus,
        CurrentSalary: this.data.response.CurrentSalary,
        CurrentPayRate: this.data.response.CurrentPayRate,
        NextPayChange: this.data.response.NextPayChange,
        TerminationDate: this.data.response.TerminationDate,
        TerminatedBy: this.data.response.TerminatedBy,
        TerminationReason: this.data.response.TerminationReason,
        TerminatedStatus: this.data.response.TerminatedStatus,
        ChangeSalaries: [],
        username: this.data.response.PrimaryEmail

      }

      this.jobBackup = deepcopy(this.responseModel)

      this.jobForm = this.jobBackup

    },

    'jobForm.ActiveStatus' () {

      if (this.jobForm.ActiveStatus == true) {
        this.jobForm.TerminatedBy = ''
        this.jobForm.TerminationReason = ''
        this.jobForm.TerminationDate = ''
        this.jobForm.IsActive = true
      } else {
        this.jobForm.TerminatedBy = this.data.response.TerminatedBy
        this.jobForm.TerminationReason = this.data.response.TerminationReason
        this.jobForm.TerminationDate = this.data.response.TerminationDate
      }

    },

    'jobForm.TerminatedStatus' () {

    },

    'jobForm.LocationId' () {
      this.locationNames = ''
      if (this.jobForm.LocationId.length > 0) {

        for (var i = 0, len = this.locations.length; i < len; i++) {
          for (var j = 0, len2 = this.jobForm.LocationId.length; j < len2; j++) {
            if (this.locations[i].LocationId == this.jobForm.LocationId[j]) {

              if (this.locationNames.length > 0)
                this.locationNames += ', '
              this.locationNames += this.locations[i].LocationName
            }
          }
        }

      }
    },
    'jobForm.PositionId' () {
      this.positionNames = ''
      if (this.jobForm.PositionId.length > 0) {

        for (var i = 0, len = this.positions.length; i < len; i++) {
          for (var j = 0, len2 = this.jobForm.PositionId.length; j < len2; j++) {
            if (this.positions[i].PositionId == this.jobForm.PositionId[j]) {
              if (this.positionNames.length > 0) {

              }

              if (this.positionNames.length > 0)
                this.positionNames += ', '
              this.positionNames += this.positions[i].PositionName
            }
          }
        }
        this.positionNames = this.positionNames.replace(/\,$/, '')
      }
    }

  },
  methods: {
    addSalary() {
      var model = {
        Salary: this.jobForm.CurrentSalary,
        PayRate: this.jobForm.CurrentPayRate,
        PayTo: this.$moment(this.jobForm.NextPayChange).format('MM-DD-YYYY')

      }

      this.salaryBack.push(model)
      this.jobForm.ChangeSalaries.push(model)

      /*      this.jobForm['CurrentSalary'] = this.data.response.CurrentSalary
       this.jobForm['CurrentPayRate'] = this.data.response.CurrentPayRate
       this.jobForm['NextPayChange'] = this.data.response.NextPayChange*/
      this.$notify({

        title: 'Success',

        message: 'Salary info added to list please save',

        type: 'success'

      })
    },

    CommonFinder(parentarray, childarray, parentkey, childkey, desiredkey, assignName) {

      for (var i = 0, len = parentarray.length; i < len; i++) {
        for (var j = 0, len2 = childarray.length; j < len2; j++) {
          if (parentarray[i].parentkey == childarray.childkey[j]) {

            this.locationNames += parentarray[i].desiredkey + ','
          }
        }
      }

    },
    backProfile() {
      this.$router.push('/addpersonnel')

    },

    cEdit() {

      if (this.data['isEdit'] == true) {
        this.data['isEdit'] = false
      } else if (this.data['isEdit'] == false) {
        this.data['isEdit'] = true
      }

    },
    modalCancel() {
      this.salaryBack = []
      if ($('#PostsignupModel').length > 0) {
        $('#PostsignupModel').modal('hide')
      } else {

        this.jobForm = deepcopy(this.responseModel)
        //this.jobForm.LocationId = this.data.response.LocationId
        this.jobForm.ChangeSalaries = []
        //FG - FOOF - Jun 2 2019 changed line below, it used to set isEdit to true... 
        //     that didn't seem right
        //     ALSO the line below used to be in the "else block" just above but I make sure
        //     isEdit is false regardless of anything else if the update is cancelled
        this.data['isEdit'] = false //if the update is cancelled then go back to view instead of edit
      }

    },
    getLocations() {
      let context = this

      service.GetLocations().then(function (response) {

        context.locations = response

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })

      })

    },
    testClick(x) {
      alert("I WAS CLICKED")
    },
    
    optionClicked(x,y) {
      alert("Option clicked");
    },

    getPosition() {
      let context = this

      //FG - FOOF - After Cert - First Release - added the parm to the GetPositions call
      service.GetPositions(this.personelId).then(function (response) {

        context.positions = response
        //FG - FOOF - After Cert - First Release Security (if any of the positions is not selectable it
        //means the person being editted has at least one role whose ordinance is greater than that of
        //the person doing the editing... when this is the case the termination settings need to be
        //disabled.)
        for(var i=0;i<positions.length;i++) {
            if(context.positions[i].isSelectable == false)
              context.disableForRoleOrdination = true;
              break;
        }

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })

      })
    },

    GetMainUsers(id) {
      let context = this

      service.GetMainUsers(id).then(function (response) {

        context.users = response

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })

      })
    },

    ViewSalary() {

      let context = this

      service.GetPersonnelSalaries(this.personelId).then(function (response) {

        context.salaries = response ? response : []
        if (context.salaryBack.length > 0) {

          context.salaryBack.map(function (el, index) {

            if (index == 0) {
              if (context.salaries.length > 0) {
                el['PayFrom'] = context.salaries[context.salaries.length - 1].PayTo
              } else {
                el['PayFrom'] = el['PayTo']
              }

            } else {

              el['PayFrom'] = context.salaryBack[index - 1].PayTo
            }

          })

          context.salaryBack.map(function (el) {

            context.salaries.push(el)

          })
        }

        $('#ViewSalary').modal('show')

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })

      })

    },

    updateJob() {
      let context = this

      /*  if(this.jobForm.ChangeSalaries.length > 0)
       {
       this.jobForm["CurrentSalary"] =  this.jobBackup.CurrentSalary
       this.jobForm["CurrentPayRate"] =  this.jobBackup.CurrentPayRate
       this.jobForm["NextPayChange"] =  this.jobBackup.NextPayChange
       }*/

      this.jobForm['IsActive'] = this.jobForm.ActiveStatus

      if (this.jobForm.HiredOn) {
        this.jobForm['HiredOn'] = this.$moment(this.jobForm['HiredOn']).format('MM-DD-YYYY')
      }
      if (this.jobForm.TerminationDate) {
        this.jobForm['TerminationDate'] = this.$moment(this.jobForm['TerminationDate']).format('MM-DD-YYYY')
      }
      if (this.jobForm.NextPayChange) {
        this.jobForm['NextPayChange'] = this.$moment(this.jobForm['NextPayChange']).format('MM-DD-YYYY')
      }

      loader.startLoader()

      service.UpdatePersonnelJobDetails(this.jobForm).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
          loader.stopLoader()
          return;
        }

        loader.stopLoader()
        if (context.isself) {
          context.$notify({
            title: 'Success',
            message: 'Please login again to apply the changes',
            type: 'success'
          })
          context.$localStorage.remove('authentication')
          window.globallocid = null
          context.$router.push('/login')
        } else {
          //FG - FOOF - AFTER CERT - First Release Security - seems the broadcast below is not needed
          //            AND when it is in place causes problems
          //context.$router.app.$emit('updatedinfo')
          context.data['isEdit'] = true
          context.$notify({

            title: 'Success',

            message: 'Job  Details Updated',

            type: 'success'

          })
        }

      }, (error) => {

        context.data['isEdit'] = true
        context.personalForm = deepcopy(context.responseModel)
        context.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
        loader.stopLoader()

      })

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Jobdetails/Jobdetails.controller.js